import * as React from 'react';
import Button from '@mui/material/Button';
import { styled } from '@mui/material/styles';
import Dialog from '@mui/material/Dialog';
import DialogTitle from '@mui/material/DialogTitle';
import DialogContent from '@mui/material/DialogContent';
import DialogActions from '@mui/material/DialogActions';
import IconButton from '@mui/material/IconButton';
import Paper from '@mui/material/Paper'
import CloseIcon from '@mui/icons-material/Close';
import AddIcon from '@mui/icons-material/Add';
import Fab from '@mui/material/Fab';
import Grid from '@mui/material/Grid2';
import SettingsIcon from '@mui/icons-material/Settings';
import MenuItem from '@mui/material/MenuItem';

import Select, { SelectChangeEvent } from '@mui/material/Select';


import CameraAltIcon from '@mui/icons-material/CameraAlt';


import axios from "axios";
import Swal from 'sweetalert2';

import { Divider, TextField, Typography } from '@mui/material';


function EditarUsuarios(params) {
    const baseUsuario = {
        id: "",
        nombre: "",
        email: "",
        rol: "",
        newPassword: "",
        proyectos: []
    }

    const baseProyecto = {
        proyecto_id: "3",
        proyecto_permisos: {
            ver: false,
            editar: false,
            crear: false,
            eliminar: false
        }
    }


    const [tempUsuario, setTempUsuario] = React.useState({
        id: "",
        nombre: "",
        email: "",
        rol: "",
        newPassword: "",
        proyectos: []
    })
    const [open, setOpen] = React.useState(false);

    React.useEffect(() => {
        // if (!params.usuario) return false

        let varUsuario = { ...tempUsuario };
        varUsuario.id = params.usuario.id
        varUsuario.nombre = params.usuario.nombre
        varUsuario.email = params.usuario.email
        varUsuario.rol = params.usuario.rol
        varUsuario.proyectos = params.usuario.proyectos
        setTempUsuario(varUsuario);
    }, [params.usuario])

    const handleOpen = () => {
        // console.log(params.usuario);
        setOpen(true);
    };

    const handleClose = () => {
        setOpen(false);
        setNewProyecto(null)
    };

    const handleCancelar = () => {
        handleClose();
    }

    const handleSaveUser = () => {
        params.editarUsuario(tempUsuario)
    }

    const handleChangeData = (e) => {
        let varUsuario = { ...tempUsuario };

        switch (e.target.name) {
            case "nomber":
                varUsuario.nombre = e.target.value
                break;
            case "rol":
                varUsuario.rol = e.target.value
                break;
            case "correo":
                varUsuario.email = e.target.value
                break;
            case "contra":
                varUsuario.newPassword = e.target.value
                break;

            default:
                break;
        }
        // console.log(varUsuario);

        setTempUsuario(varUsuario);
    }

    const [newProyecto, setNewProyecto] = React.useState(null)

    const asignarProyecto = (e) => {
        setNewProyecto(e.target.value)
    }

    const asignarPermiso = async (usuarioId, proyectoId) => {
        params.cargando("Asignando...")
        try {
            const response = await axios.post(
                "https://apimedidas.ahouseinterior.com/asignar_permiso.php",
                {
                    usuario_id: usuarioId,
                    proyecto_id: proyectoId,
                },
                {
                    withCredentials: true, // Para enviar cookies/sesión
                }
            );

            if (response.data.status === "success") {
                params.alerta("Permiso Asignado Correctamente.", "success")
                setNewProyecto(null)
                params.fetchUsuarios()
            } else {
                params.alerta(response.data.message, "error")
            }
        } catch (error) {
            console.error("Error al asignar permiso:", error);
            params.alerta("Error al asignar permiso", "error")
        }
    };

    const confirmarEliminarPermisosDeProyecto = (usuarioId, proyectoId) => {
        Swal.fire({
            title: '¿Estás seguro?',
            text: "Vas a quitarle todos los permisos!",
            icon: 'warning',
            showCancelButton: true,
            cancelButtonText: 'Cancelar',
            confirmButtonText: 'Quitar',
        }).then((result) => {
            if (result.isConfirmed) {
                eliminarPermisosDeProyecto(usuarioId, proyectoId)
            } else {
                params.alerta("Accion Cancelada", "error")
            }
        });
    }

    const eliminarPermisosDeProyecto = async (usuarioId, proyectoId) => {
        params.cargando("Eliminando...")
        try {
            const response = await axios.post(
                "https://apimedidas.ahouseinterior.com/eliminar_del_proyecto.php",
                {
                    usuario_id: usuarioId,
                    proyecto_id: proyectoId,
                },
                {
                    withCredentials: true, // Para enviar cookies/sesión
                }
            );

            if (response.data.status === "success") {
                params.alerta("Eliminado", "success")
                params.fetchUsuarios()
            } else {
                params.alerta(response.data.message, "error")
            }
        } catch (error) {
            console.error("Error al eliminar permisos:", error);
            params.alerta('Error al eliminar permisos', "error")
        }
    };


    return (
        <React.Fragment>
            <IconButton color="success" aria-label="add" onClick={handleOpen}>
                <SettingsIcon />
            </IconButton>
            <Dialog
                fullScreen
                onClose={handleClose}
                aria-labelledby="customized-dialog-title"
                open={open}
                disableRestoreFocus
            >
                <DialogTitle sx={{ m: 0, p: 2 }} id="customized-dialog-title">
                    Editar Usuarios
                </DialogTitle>
                <IconButton
                    aria-label="close"
                    onClick={handleClose}
                    sx={(theme) => ({
                        position: 'absolute',
                        right: 8,
                        top: 8,
                        color: theme.palette.grey[500],
                    })}
                >
                    <CloseIcon />
                </IconButton>
                <DialogContent dividers>

                    <Grid container spacing={2} rowSpacing={3} columns={10} >
                        <Grid size={10}>
                            <Paper style={{ padding: "10px" }} >
                                <Grid container spacing={2} rowSpacing={1} columns={10} >
                                    <Grid size={5}>
                                        <Typography variant='h6' color='primary'>[{params.usuario.id}] - {params.usuario.nombre}</Typography>
                                    </Grid>
                                    <Grid size={5}>
                                        <Typography style={{ textAlign: "right" }} variant='h6' color='secondary'>{params.usuario.rol}</Typography>
                                    </Grid>
                                </Grid>
                            </Paper>
                        </Grid>
                        <Grid size={10}>
                            <TextField
                                fullWidth
                                name='nomber'
                                label='Nombre'
                                variant='outlined'
                                value={tempUsuario.nombre}
                                onChange={handleChangeData}
                            />
                        </Grid>
                        {params.usuario.rol !== "admin" &&
                            <Grid size={10}>
                                <Select
                                    labelId="rol"
                                    name="rol"
                                    id="rol"
                                    value={tempUsuario.rol}
                                    displayEmpty
                                    inputProps={{ 'aria-label': 'Without label' }}
                                    fullWidth
                                    onChange={handleChangeData}
                                >
                                    <MenuItem value={"admin"}>Administrador</MenuItem>
                                    <MenuItem value={"asociado"}>Asociado</MenuItem>
                                    <MenuItem value={"visita"}>Visita</MenuItem>
                                    <MenuItem value={"inhabilitado"}>Inhabilitado</MenuItem>
                                </Select>
                            </Grid>
                        }
                        <Grid size={10}>
                            <TextField
                                fullWidth
                                name='correo'
                                label='Correo'
                                variant='outlined'
                                value={tempUsuario.email}
                                onChange={handleChangeData}
                            />
                        </Grid>
                        <Grid size={10}>
                            <TextField
                                fullWidth
                                name='contra'
                                label='Nueva Contraseña'
                                variant='outlined'
                                value={tempUsuario.newPassword}
                                onChange={handleChangeData}
                            />
                        </Grid>
                        <Grid size={10}>
                            <Button variant='contained' onClick={handleSaveUser}>
                                Guardar
                            </Button>
                        </Grid>
                        {params.usuario.rol !== "admin" &&
                            <>
                                <Grid size={10}>
                                    <Divider />
                                </Grid>
                                <Grid size={10}>
                                    <Typography>Asignar Proyecto</Typography>
                                </Grid>
                                <Grid size={7}>
                                    <Select
                                        labelId="rol"
                                        name="rol"
                                        id="rol"
                                        size='small'
                                        value={newProyecto}
                                        displayEmpty
                                        inputProps={{ 'aria-label': 'Without label' }}
                                        fullWidth
                                        onChange={asignarProyecto}
                                    >
                                        {params.proyectos &&
                                            params.proyectos
                                                .filter(
                                                    (pro) =>
                                                        !tempUsuario.proyectos.some(
                                                            (assignedPro) => assignedPro.proyecto_id === pro.id
                                                        )
                                                ) // Filtrar proyectos no asignados
                                                .map((pro, index) => (
                                                    <MenuItem value={pro.id} key={index}>
                                                        {pro.id} - {pro.nombre}
                                                    </MenuItem>
                                                ))
                                        }
                                    </Select>
                                </Grid>

                                <Grid size={3}>
                                    <Button variant='contained' onClick={() => { asignarPermiso(tempUsuario.id, newProyecto) }}>Enviar</Button>
                                </Grid>
                                <Grid size={10}>
                                    <Divider />
                                </Grid>
                            </>
                        }
                        {tempUsuario &&
                            tempUsuario.proyectos.map((proyecto, index) => (
                                <Grid size={10} key={index}>
                                    <Grid container spacing={2} rowSpacing={1} columns={10} >
                                        <Grid size={7}>
                                            <Typography variant="subtitle2">{proyecto.proyecto_id} - {proyecto.proyecto_nombre}</Typography>
                                        </Grid>
                                        <Grid size={3}>
                                            <Typography textAlign="right" variant="subtitle2" color='error' onClick={() => { confirmarEliminarPermisosDeProyecto(params.usuario.id, proyecto.proyecto_id) }}>Eliminar</Typography>
                                        </Grid>
                                        <Grid size={10}>
                                            {tempUsuario.rol === "admin" || tempUsuario.rol === "asociado" &&
                                                <div style={{ display: "flex", justifyContent: "space-between", margin: "10px 0" }}>
                                                    <Typography className={proyecto.proyecto_permisos.ver ? "buttonActive" : "buttonDisable"} onClick={() => params.cambiarPermiso("ver", proyecto.proyecto_id, tempUsuario.id)} variant="subtitle2" color={proyecto.proyecto_permisos.ver ? "primary" : "error"}>Ver</Typography>
                                                    <Typography className={proyecto.proyecto_permisos.crear ? "buttonActive" : "buttonDisable"} onClick={() => params.cambiarPermiso("crear", proyecto.proyecto_id, tempUsuario.id)} variant="subtitle2" color={proyecto.proyecto_permisos.crear ? "primary" : "error"}>Crear</Typography>
                                                    <Typography className={proyecto.proyecto_permisos.editar ? "buttonActive" : "buttonDisable"} onClick={() => params.cambiarPermiso("editar", proyecto.proyecto_id, tempUsuario.id)} variant="subtitle2" color={proyecto.proyecto_permisos.editar ? "primary" : "error"}>Editar</Typography>
                                                    <Typography className={proyecto.proyecto_permisos.eliminar ? "buttonActive" : "buttonDisable"} onClick={() => params.cambiarPermiso("eliminar", proyecto.proyecto_id, tempUsuario.id)} variant="subtitle2" color={proyecto.proyecto_permisos.eliminar ? "primary" : "error"}>Eliminar</Typography>
                                                </div>
                                            }
                                            {tempUsuario.rol === "visita" &&
                                                <div style={{ display: "flex", justifyContent: "space-between", margin: "10px 0" }}>
                                                    <Typography className={proyecto.proyecto_permisos.ver ? "buttonActive" : "buttonDisable"} onClick={() => params.cambiarPermiso("ver", proyecto.proyecto_id, tempUsuario.id)} variant="subtitle2" color={proyecto.proyecto_permisos.ver ? "primary" : "error"}>Ver</Typography>
                                                </div>
                                            }
                                        </Grid>
                                    </Grid>
                                    <Divider />
                                </Grid>
                            ))
                        }

                    </Grid>
                </DialogContent>
                {/* <DialogActions style={{ display: "flex", justifyContent: "space-between" }}>
                    <Button variant='outlined' color="error" onClick={handleCancelar}>
                        Cancelar
                    </Button>
                    <Button variant='contained' onClick={handleSaveUser}>
                        Guardar
                    </Button>
                </DialogActions> */}
            </Dialog>
        </React.Fragment>
    )
}

export default EditarUsuarios;